import * as React from 'react';

export const IconCog: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg
    height="24"
    width="24"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="var(--menu-icon)">
      <path
        d="M46.083,20,40.4,19.529a16.746,16.746,0,0,0-1.641-3.956l3.691-4.362a1,1,0,0,0-.056-1.353L38.142,5.615a1,1,0,0,0-1.353-.056l-4.361,3.69A16.853,16.853,0,0,0,28.471,7.6L28,1.917A1,1,0,0,0,27,1H21a1,1,0,0,0-1,.917L19.529,7.6a16.746,16.746,0,0,0-3.956,1.641L11.211,5.554a1,1,0,0,0-1.353.056L5.615,9.858a1,1,0,0,0-.056,1.353l3.69,4.361A16.853,16.853,0,0,0,7.6,19.529L1.917,20A1,1,0,0,0,1,21v6a1,1,0,0,0,.917,1l5.687.475a16.746,16.746,0,0,0,1.641,3.956L5.554,36.789a1,1,0,0,0,.056,1.353l4.243,4.243a1,1,0,0,0,1.352.056l4.362-3.69A16.819,16.819,0,0,0,19.529,40.4L20,46.083A1,1,0,0,0,21,47h6a1,1,0,0,0,1-.917l.476-5.691a16.83,16.83,0,0,0,3.955-1.642l4.362,3.691a1,1,0,0,0,1.353-.056l4.243-4.243a1,1,0,0,0,.056-1.353l-3.69-4.361A16.853,16.853,0,0,0,40.4,28.471L46.083,28A1,1,0,0,0,47,27V21A1,1,0,0,0,46.083,20ZM24,31a7,7,0,1,1,7-7A7,7,0,0,1,24,31Z"
        fill="var(--menu-icon)"
      />
    </g>
  </svg>
);
